/**
 * Displays a list of external “Useful Links” as a simple titled section.
 *
 * The `UsefulLinksSection` component renders a titled block containing
 * a list of helpful external resources (e.g., county GIS portal, property
 * record sites, or documentation links). Each link opens in a new browser tab.
 * 
 * -- Config.json (usefulLinks) --
 * 
 */

import React from "react";
import type { AppJsonConfig } from "../../types/config";

type Props = { links: NonNullable<AppJsonConfig["usefulLinks"]> | undefined };

const UsefulLinksSection: React.FC<Props> = ({ links }) => {
  return (
    <div className="psa-links-block">
      <div className="psa-links-title">Useful Links</div>
      <ul className="psa-links-list">
        {(links || []).map((l) => (
          <li key={l.url}>
            <a href={l.url} target="_blank" rel="noreferrer">{l.label}</a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default UsefulLinksSection;
